import { message } from 'ant-design-vue'

function getUrlParams(url?: string): any {
  let _url = url ? url : window.location.href
  _url = _url.split('#')[0] // 对于有hash的情况，去除hash
  let queryString = ''
  queryString = -1 === _url.indexOf('?') ? '' : _url.split('?')[1]
  return getParamDict(queryString)
}

function getUpdatedUrl(params) {
  let old = getUrlParams()
  let newParams = { ...old, ...params }
  for (let key of Object.keys(newParams)) {
    if (newParams[key] === '') {
      delete newParams[key]
    }
  }

  let search =
    Object.keys(newParams).length == 0
      ? ''
      : Object.keys(newParams)
          .map((key) => key + '=' + newParams[key])
          .join('&')
  return location.protocol + '//' + location.host + location.pathname + search + location.hash
}

function getParamDict(queryString: string): object {
  if (!queryString) return {}

  let dict: any = {}
  let s = queryString.split('&')
  for (let i = 0; i < s.length; i += 1) {
    let t = s[i].split('=')
    dict[decodeURIComponent(t[0])] = decodeURIComponent(t[1])
  }
  return dict
}

function msgTip(params: { type: any; msg: string }) {
  let { type, msg } = params
  let fun = message[type]
  fun(msg)
}
function getCookie(cookie_name) {
  let allcookies = document.cookie
  let cookie_pos = allcookies.indexOf(cookie_name)
  let value = ''
  if (cookie_pos != -1) {
    cookie_pos = cookie_pos + cookie_name.length + 1
    let cookie_end = allcookies.indexOf(';', cookie_pos)

    if (cookie_end == -1) {
      cookie_end = allcookies.length
    }
    value = unescape(allcookies.substring(cookie_pos, cookie_end))
  }
  return value
}

// 判断两个对象内容是否一致
function isObjectValueEqual(a, b) {
  let aProps = Object.getOwnPropertyNames(a)
  let bProps = Object.getOwnPropertyNames(b)

  if (aProps.length != bProps.length) {
    return false
  }

  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i]
    if (a[propName] !== b[propName]) {
      return false
    }
  }

  return true
}
export { msgTip, getUrlParams, getParamDict, getCookie, isObjectValueEqual, getUpdatedUrl }
